import * as tslib_1 from "tslib";
import React from 'react';
import ReactPlayer from 'react-player';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { mergeStyles, validate } from 'wix-rich-content-common';
import isEqual from 'lodash.isequal';
import schema from './data-schema.json';
import styles from './styles/video-viewer.scss';
import { YouTube } from 'react-player/lib/players/YouTube';
import { Vimeo } from 'react-player/lib/players/Vimeo';
import { Facebook } from 'react-player/lib/players/Facebook';
import { Twitch } from 'react-player/lib/players/Twitch';
var players = [YouTube, Facebook, Twitch, Vimeo];
export var canPlay = function (url) {
    return players.some(function (Player) { return Player.canPlay(url); });
};
var VideoViewer = /** @class */ (function (_super) {
    tslib_1.__extends(VideoViewer, _super);
    function VideoViewer(props) {
        var _this = _super.call(this, props) || this;
        validate(props.componentData, schema);
        _this.styles = mergeStyles({ styles: styles, theme: props.theme });
        return _this;
    }
    VideoViewer.prototype.componentWillReceiveProps = function (nextProps) {
        if (!isEqual(nextProps.componentData, this.props.componentData)) {
            validate(nextProps.componentData, schema);
        }
    };
    VideoViewer.prototype.render = function () {
        var _a = this.props, componentData = _a.componentData, theme = _a.theme, rest = tslib_1.__rest(_a, ["componentData", "theme"]); // eslint-disable-line no-unused-vars
        if (!canPlay(componentData.src)) {
            return null;
        }
        return (React.createElement(ReactPlayer, tslib_1.__assign({ className: classNames(this.styles.video_player), url: componentData.src }, rest)));
    };
    VideoViewer.propTypes = {
        componentData: PropTypes.object.isRequired,
        theme: PropTypes.object,
        onReady: PropTypes.func,
        onStart: PropTypes.func,
        controls: PropTypes.bool,
        width: PropTypes.string,
        height: PropTypes.string,
    };
    VideoViewer.defaultProps = {
        width: '100%',
        height: '100%',
        controls: true,
    };
    return VideoViewer;
}(React.Component));
export default VideoViewer;
//# sourceMappingURL=video-viewer.js.map